import React from 'react';
import styled from 'styled-components';
import type { IResponsiveImageModel } from 'shared/interfaces/responsiveImage';
import { backgroundImageStyling } from './styles';

const BackgroundImage = styled.picture<{ desktopImageUrl: string; mobileImageUrl: string }>`
    ${backgroundImageStyling}

    flex: 1 1 0%;
    width: 100%;
    height: 100%;
    background-size: cover;

    .preview--desktop-small &,
    .preview--desktop-large & {
        background-image: url(${({ desktopImageUrl }): string => desktopImageUrl});
    }
    .preview--mobile-small &,
    .preview--mobile-large & {
        background-image: url(${({ mobileImageUrl }): string => mobileImageUrl});
    }
`;

const PreviewBackgroundImage = (image: IResponsiveImageModel): JSX.Element => {
    const { sources, fallBackUrl } = image;

    const sortedSources = sources?.sort(({ breakPoint }) => (!breakPoint?.minWidth ? -1 : breakPoint?.minWidth));

    const [lastSource] = sortedSources?.slice(-1) || [];
    const [firstImage] = lastSource?.images || [];
    const [mobileImageSource] = sortedSources || [];
    const [first] = mobileImageSource?.images || [];

    const desktopImageUrl = !sortedSources?.length ? firstImage.url : fallBackUrl;
    const { url: mobileImageUrl } = first;

    return <BackgroundImage desktopImageUrl={desktopImageUrl || ''} mobileImageUrl={mobileImageUrl || ''} />;
};

export default PreviewBackgroundImage;
